import { toHumanCase } from "./common";

export function enumToOptions<T extends Record<string, string | number>>(enumToFormat: T) {
  return Object.keys(enumToFormat).map((key) => ({
    label: toHumanCase(key),
    value: enumToFormat[key as keyof T],
  }));
}
